import React from "react";
import "./page.css";
import {
  TextField,
  Slider,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Divider,
  Accordion,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { NumberFormatCustomFiveDigits } from "../components/NumberFormatCustom";
import { calculate, forList } from "../functions/CalculateTaishoku.js";

import handleUpdate from "../functions/handleUpdate";
import Tutrial from "../components/Tutrial";
import TutrialImage1 from "../asset/tutrial/ser1/tutrial1.gif";
import TutrialImage2 from "../asset/tutrial/ser1/tutrial2.jpg";

import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import StackedColumn2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

import { LogoCover } from "../components/LogoCover";
import firebase from "../firebase";

ReactFC.fcRoot(FusionCharts, StackedColumn2D, FusionTheme);

const dataSource = {
  chart: {
    caption: "退職所得控除と所得税の割合",
    numberSuffix: "万円",
    theme: "fusion",
    yAxisValuesPadding: 0,
    formatNumberScale: 0,
    usePlotGradientColor: 0,
    yAxisMaxValue: 0,
    valueFontColor: "#ffffff",
    plotBorderColor: "#bababa",
    plotBorderThickness: 1,
    reverseLegend: 1,
    bgColor: "#ffffff",
    showXAxisLine: true,
    showYAxisLine: true,
  },
  categories: [
    {
      category: [
        {
          label: "",
        },
      ],
    },
  ],
  dataset: [
    {
      seriesname: "所得税額",
      color: "#D63135",
      data: [
        {
          value: "",
        },
      ],
    },
    {
      seriesname: "控除後1/2-税額",
      color: "#005a98",
      data: [
        {
          value: "",
        },
      ],
    },
    {
      seriesname: "控除後の1/2",
      color: "#004573",
      data: [
        {
          value: "",
        },
      ],
    },
    {
      seriesname: "退職所得控除",
      color: "#002E4D",
      data: [
        {
          value: "",
        },
      ],
    },
  ],
};

const chartConfigs = {
  type: "stackedcolumn2d", // The chart type
  width: "100%", // Width of the chart
  height: "400", // Height of the chart
  dataFormat: "json", // Data type
  dataSource: dataSource,
};

let list = forList(10000, 10);
let result = calculate(10000, 10);

class SeverancePay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: dataSource,
      income: "",
      duration: 20,
      expanded: false,
      calculationCount: 0,
      tutrial: false,
    };
  }

  componentDidMount() {
    result = calculate(this.state.income, this.state.duration);
    list = forList(this.state.income, this.state.duration);
    let dataSource = this.state.dataSource;
    dataSource.dataset[3].data[0].value = Number(result.taishokuKoujyo);
    dataSource.dataset[2].data[0].value = Number(result.taishokuShotoku);
    dataSource.dataset[1].data[0].value = Math.round(
      Number(
        result.taishokuShotoku -
        (result.shotokuZei + result.shimin + result.kenmin)
      )
    );
    dataSource.dataset[0].data[0].value = Math.round(
      Number(result.shotokuZei + result.shimin + result.kenmin)
    );
    dataSource.chart.yAxisMaxValue =
      Number(result.taishokuKoujyo) +
      Number(result.taishokuShotoku) +
      Math.round(
        Number(
          result.taishokuShotoku -
          (result.shotokuZei + result.shimin + result.kenmin)
        )
      ) +
      Math.round(Number(result.shotokuZei + result.shimin + result.kenmin));
    this.setState({ dataSource: dataSource });

    const ended = localStorage.getItem("tutrial5");
    if (ended) {
      this.setState({ tutrial: false });
    } else {
      this.setState({ tutrial: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //console.log('start update checking top');
    handleUpdate();
    const analytics = firebase.analytics();
    result = calculate(this.state.income, this.state.duration);
    list = forList(this.state.income, this.state.duration);
    if (
      this.state.income !== prevState.income ||
      this.state.duration !== prevState.duration
    ) {
      let dataSource = this.state.dataSource;
      dataSource.dataset[3].data[0].value = Number(result.taishokuKoujyo);
      dataSource.dataset[2].data[0].value = Number(result.taishokuShotoku);
      dataSource.dataset[1].data[0].value = Math.round(
        Number(
          result.taishokuShotoku -
          (result.shotokuZei + result.shimin + result.kenmin)
        )
      );
      dataSource.dataset[0].data[0].value = Math.round(
        Number(result.shotokuZei + result.shimin + result.kenmin)
      );
      dataSource.chart.yAxisMaxValue =
        Number(result.taishokuKoujyo) +
        Number(result.taishokuShotoku) +
        Math.round(
          Number(
            result.taishokuShotoku -
            (result.shotokuZei + result.shimin + result.kenmin)
          )
        ) +
        Math.round(Number(result.shotokuZei + result.shimin + result.kenmin));
      this.setState({ dataSource: dataSource });
      analytics.logEvent("calculation");
      this.setState({ calculationCount: this.state.calculationCount + 1 });
      if (this.state.calculationCount % 10 === 0) {
        //console.log("calculate 10 times :", this.state.calculationCount);
        analytics.logEvent("calculate10times");
      }
    }
  }

  closeTutrial = () => {
    localStorage.setItem("tutrial5", "ended");
    this.setState({ tutrial: false })
  };

  render() {
    //console.log('prpos', this.props);
    return (
      <>
        {this.state.tutrial ? <Tutrial closeTutrial={this.closeTutrial} image1={TutrialImage1} image2={TutrialImage2} /> :
          <div className="container">
            <section className="userArea">
              <TextField
                id="input"
                label="退職金額"
                onChange={(event) => {
                  this.setState({ income: event.target.value });
                }}
                value={`${this.state.income}`}
                InputProps={{
                  inputComponent: NumberFormatCustomFiveDigits,
                  type: 'tel'
                }}
                fullWidth={true}
                color={"secondary"}
              />
              <div style={{ height: 50 }}>
                <div style={{ fontSize: 16, marginTop: 20 }}>
                  <span style={{ color: "#007DB3", fontWeight: "bold" }}>
                    役員在任年数
                  </span>
                  : {this.state.duration} 年
                </div>
                <Slider
                  value={this.state.duration}
                  max={70}
                  min={6}
                  step={1}
                  onChange={(event, newValue) =>
                    this.setState({ duration: newValue })
                  }
                  color={"secondary"}
                />
              </div>
            </section>
            <Divider style={{ backgroundColor: "#cfd8dc" }} />
            <section className="resultArea">
              <div className="listContainer" style={{ padding: 0 }}>
                {list[0].map((l, i) => (
                  <TableContainer key={i}>
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            {l.name}
                          </TableCell>
                          <TableCell align="right">{l.value}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                ))}
              </div>
              <div className="listContainer" style={{ padding: 0 }}>
                <Accordion square={true}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>計算の詳細</Typography>
                  </AccordionSummary>
                  <div>
                    {list[1].map((l, i) => (
                      <TableContainer key={i}>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                {l.name}
                              </TableCell>
                              <TableCell align="right">{l.value}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ))}
                  </div>
                  <div>
                    {list[2].map((l, i) => (
                      <TableContainer key={i}>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                {l.name}
                              </TableCell>
                              <TableCell align="right">{l.value}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ))}
                  </div>
                </Accordion>
              </div>
              <div className="chartContainer">
                <ReactFC {...chartConfigs} />
                <LogoCover></LogoCover>
              </div>
            </section>
          </div>}
      </>
    );
  }
}

export default SeverancePay;
